import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopBar from '../other-components/TopBar';
import "../../MainStyle.css";
import {
    LIVE_CHAT_URL,
    openNewPage,
} from "../modals/Constants";
import { setStorage, getStorage } from "../modals/Storage";
import general from "../css/General.module.css";

function HelpSupport() {
    const navigate = useNavigate();

    const [pageConst, setConstants] = useState({
        pageTitle: "Help & Support",
    });

    useEffect(() => {
        if (!getStorage("uid")) {
            navigate("/home", { replace: true });
        }
    }, []);

    return (
        <div
            className={[
                general.appContents
            ].join(" ")}
        >
            <TopBar intentData={pageConst} multiBtn={true} multiBtn1="" multiBtn2="" background={1} />

            <div className="col-view resp-w-500x pd-30-15 mg-t-55 br-5 bg-custom-1">
                <div className="pd-15">
                    <div className="v-center ft-sz-20 pd-10-15 cl-white br-5 bg-selected" onClick={() => openNewPage(LIVE_CHAT_URL)}>Live Support 24x7</div>
                    <div className="v-center ft-sz-20 pd-10-15 cl-white mg-t-15 br-5 bg-selected" onClick={() => openNewPage(getStorage("telegramURL"))}>Live Support Telegram</div>
                </div>
            </div>
        </div >
    );
}

export default HelpSupport;
